module.exports = __webpack_public_path__ + "static/img/surface7.9262e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface7.png
// module id = SgKF
// module chunks = 2